import * as React from "react";
import { nativeSheetExpandPreference } from "@/lib/native/nativeSheetExpandPreference";

/** Open a native sheet already expanded (heavy flows: post-ad, test doc view). */
export function useNativeSheetOpensExpanded(
  open: boolean,
  enabled = true,
): void {
  React.useLayoutEffect(() => {
    if (open && enabled) {
      nativeSheetExpandPreference.set(true);
    }
  }, [open, enabled]);
}
